import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-building-use.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-building-use.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationSearchConstants } from "../application-search-constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { AlertType } from "../../../../shared/models/alert";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { Store } from "@ngrx/store";
import { ApiLookupConstants } from "../../../../shared/constants/api-constants/api-lookup.constants";
import { HttpClient } from "@angular/common/http";
import { ViewApplicationDetailsBpConstants } from "../../../../application/view-application/modules/bp/view-application-details-bp/view-application-details-bp.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
let SearchBuildingUseComponent = class SearchBuildingUseComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    http;
    changeDetectorRef;
    store;
    buildingUseOptions = [];
    _destroy$ = new Subject();
    buildingUseLabel = ApplicationSearchConstants.FORM_CONTROLS.buildingUseLabel;
    buildingUseFormControl = ApplicationSearchConstants.FORM_CONTROLS.buildingUseFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    applicationSearchCallback;
    tabChanged;
    buildingUseOptionsForm;
    getBuildingUseSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, http, changeDetectorRef, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.http = http;
        this.changeDetectorRef = changeDetectorRef;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and (name eq 'ResidentialBuildingUse' or name eq 'NonResidentialBuildingUse')`,
        };
        this.getBuildingUseSubscription = this.http.get(ApiLookupConstants.URL, { params }).pipe(map(lookups => {
            return lookups;
        })).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsBpConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    setUpForm() {
        this.buildingUseOptionsForm = new FormGroup({
            buildingUseFormControl: new FormControl("")
        });
    }
    searchApplication() {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.buildingUseOptionsForm = val;
            }
        });
        const buildingUseName = this.buildingUseOptionsForm.get(this.buildingUseFormControl).value;
        if (buildingUseName !== "") {
            this.applicationSearchCallback(this.applicationSearchService.searchByBuildingUse(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, buildingUseName));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    onGetLookupsCompleted(response) {
        const nonResidentialBuildingUse = [];
        this.buildingUseOptions = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "NonResidentialBuildingUse") {
                    this.buildingUseOptions.push(JSON.parse(item.content));
                }
                if (item.name === "ResidentialBuildingUse") {
                    this.buildingUseOptions.push(JSON.parse(item.content));
                }
            });
        }
        const uniqueBuildingUseOptions = {};
        const distinctBuildingUseOptionsArray = [];
        this.buildingUseOptions.forEach((buildingUse) => {
            if (!uniqueBuildingUseOptions[buildingUse.value]) {
                distinctBuildingUseOptionsArray.push(buildingUse);
                uniqueBuildingUseOptions[buildingUse.value] = true;
            }
        });
        this.buildingUseOptions = [];
        this.buildingUseOptions = distinctBuildingUseOptionsArray;
        this.buildingUseOptions.sort((a, b) => a?.value.localeCompare(b.value));
        this.changeDetectorRef.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: HttpClient },
        { type: ChangeDetectorRef },
        { type: Store }
    ];
};
SearchBuildingUseComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-building-use",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchBuildingUseComponent);
export { SearchBuildingUseComponent };
